const PRGM_PROGRAM_DESCRIPTIONS: Record<string, string> = {
  "Title I Part A Basic Targeted":
    "This program should be used for identified children receiving Title I services from a Targeted Assistance School (TAS). It should not be added for children in schools with Title I Schoolwide Programs (SWP).",
  "Free Meal Program":
    "This program should be used for children associated with an approved application for free meals under the National School Lunch Program (NSLP)",
  "Reduced-Price Meal Program":
    "This program should be used for children associated with an approved application for reduced price meals under the National School Lunch Program (NSLP)",
  "Homeless Program":
    "This program should be used for any child that meets the McKinney-Vento definition of homeless: an individual who lacks a fixed, regular, and adequate nighttime residence.",
  "Tribal Foster Youth":
    "This program should be used for any child identified as a foster youth who is under the jurisdiction of a Tribal Court",
};

export function getPRGMProgramDescription(programText: string | undefined) {
  if (!programText) {
    return "Select an Education Program to see more information about its requirements.";
  }
  return PRGM_PROGRAM_DESCRIPTIONS[programText.trim()] ?? "";
}
